import { createRoot } from 'react-dom/client';

import modelLoader from '@rhino-project/core/models';

import '@/styles/styles.scss';
import { initTheme } from '@/utils/theme';
import { persistSignupAttributionFromLocation } from '@/utils/authAnalytics';

// Build marker: proves which branch/build the served bundle came from. Look for
// this line in the browser console to tell a stale deployment from a fresh one.
console.warn(
  '[codalio] build marker: cod-2154-nestjs-integration | backend-stack selector: PRESENT | deploy: 2026-09-10'
);

// Capture UTMs before React Router can Navigate to a clean path.
initTheme();
persistSignupAttributionFromLocation();

modelLoader.loadModels().then(async () => {
  // Import the Root dynamically so that other modelLoader uses are assured
  // to have access to the already loaded models
  const { default: Root } = await import('@/Root');

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<Root />);
});
